import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {
    width: '100%',
  },
  summary: {
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.down('md')]: {
      paddingBottom: theme.spacing(1),
    },
  },
  service: {
    margin: theme.spacing(0, 0, 1, 1),
  },
  totalLine: {
    paddingTop: theme.spacing(1),
  },
  serviceDots: {
    flex: 1,
    minWidth: theme.spacing(1),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    height: 1,
    alignSelf: 'flex-end',
    backgroundImage: `radial-gradient(circle at center, ${theme.palette.divider} 1px, transparent 1px)`,
    backgroundSize: '6px 1px',
    backgroundRepeat: 'repeat-x',
    backgroundPosition: '0 100%',
  },
  addOn: {
    marginLeft: theme.spacing(5),
    marginRight: theme.spacing(0.5),
  },
}));
